import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";

function SVGCarne(props) {
	return (
		<SvgIcon {...props} viewBox={"0 0 48 48"}>
			<path d="M30.4365,11.3518c-1.0216-.4193-2.1896,.0691-2.6089,1.0908-.4192,1.0216,.0692,2.1898,1.0908,2.609,1.0216,.4192,2.1896-.0691,2.6088-1.0908,.4193-1.0217-.0691-2.1897-1.0907-2.609Z" />
			<path d="M42.1916,12.9911c-.6343-1.1885-1.4443-2.2812-2.4087-3.2461l-1.6812-1.6816c-.9624-.9619-2.0542-1.7715-3.2451-2.4072-3.1816-1.6963-6.9106-1.7979-10.23-.2783-3.417,1.5645-5.8477,4.5479-6.6689,8.1865-.6548,2.9004-2.0083,6.9912-4.7373,10.042-.876,.8984-1.3501,2.0859-1.3364,3.3506,.0137,1.2695,.5186,2.4658,1.4219,3.3691l.5855,.5854-3.0236,3.0234c-1.5119-1.3245-3.8141-1.2881-5.2646,.1479-.7339,.7275-1.1401,1.6973-1.1445,2.7324-.0044,1.0342,.3936,2.0078,1.1211,2.7412,.4985,.502,1.1113,.8516,1.7808,1.0225,.1426,.7334,.4971,1.4209,1.041,1.9688,.7275,.7354,1.6982,1.1426,2.7314,1.1455h.0195c1.0273,0,1.9937-.3975,2.7222-1.1201,.7339-.7275,1.1401-1.6973,1.1445-2.7324,.0044-1.0342-.3936-2.0078-1.1211-2.7412l-.0015-.002c-.0897-.0903-.1877-.1698-.2853-.2499l3.1082-3.1083,.8026,.8025c.9463,.9463,2.186,1.4199,3.4209,1.4199,1.1948,0,2.3853-.4443,3.2979-1.334,3.0508-2.7295,7.1421-4.083,10.0425-4.7373,3.6387-.8223,6.6226-3.2529,8.187-6.6699,1.5195-3.3203,1.418-7.0479-.2788-10.2295Zm-3.3584,8.5645c-1.0405,2.2725-3.02,3.8887-5.4307,4.4326-3.3755,.7627-8.1748,2.3691-11.8701,5.6963-.0264,.0234-.0518,.0479-.0762,.0723-.2935,.292-.79,.2725-1.1055-.043l-1.3296-1.3301h-.0005l-2.8862-2.8857c-.2148-.2148-.2495-.458-.2505-.584-.002-.1416,.0332-.3477,.2075-.5225,.0249-.0244,.0488-.0498,.0723-.0762,3.3267-3.6953,4.9336-8.4951,5.6953-11.8701,.5444-2.4102,2.1602-4.3896,4.4326-5.4307,1.0273-.4707,2.1128-.7051,3.1904-.7051,1.2041,0,2.3989,.293,3.4917,.876,.8428,.4492,1.6167,1.0244,2.3003,1.707l1.6797,1.6797c.6851,.6865,1.2598,1.46,1.7085,2.3018,1.1045,2.0703,1.167,4.5059,.1709,6.6816Z" />
		</SvgIcon>
	);
}

function SVGPesce(props) {
	return (
		<SvgIcon {...props} viewBox={"0 0 48 48"}>
			<path d="M34.6742,20.8361c-.957-.3927-2.0512,.0648-2.4439,1.0219-.3928,.9573,.0647,2.0515,1.0217,2.4443,.957,.3928,2.0512-.0647,2.444-1.022,.3927-.957-.0648-2.0514-1.0218-2.4442Z" />
			<path d="M42.9386,20.8316c-1.6582-3.3311-4.0913-5.5322-7.2314-6.542-2.5439-.8167-5.1505-.6987-7.3354-.2786-.4154-.6504-2.7736-3.8773-8.2012-3.1414l-.0033,.0007c-.4085,.0554-.804,.2308-1.1227,.5393-3.803,3.6816-2.9116,7.3938-2.6138,8.3014-.8091,.6-1.4288,1.1014-2.0196,1.5826-.5214-.8362-1.1201-1.6855-1.9033-2.4309-1.4365-1.3682-3.1348-2.3076-5.0522-2.793-1.5835-.3984-2.4297,.3838-2.791,.8857-.1812,.251-.3091,.5498-.3677,.8291-.0117,.0488-.9614,5.2568,.9424,8.3076,.0288,.0469,.0586,.0928,.0884,.1377-.0356,.0576-.0708,.1152-.105,.1748-1.7969,3.1299-.7197,8.2598-.7192,8.2598,.083,.3379,.2222,.6348,.4121,.8779,.2441,.3145,.8521,.9219,1.8994,.9219,.2827,0,.5977-.0439,.9458-.1504,1.8911-.5742,3.5562-1.5889,4.9507-3.0176,.7734-.7939,1.3555-1.6865,1.8672-2.5732,.1097-.0831,.2114-.1786,.3034-.2852,.6434,.4929,1.3433,1.0168,2.3152,1.6719,1.8779,1.2646,3.2754,2.082,6.1074,3.2871,.5205,.248,4.0278,1.8418,8.1436,1.8418,1.4536,0,2.9839-.1992,4.4849-.7266,3.1299-1.1006,5.5215-3.3779,7.1079-6.7695,.0112-.0244,.022-.0488,.0322-.0732,2.0234-4.8154-.082-8.7451-.1348-8.8379Zm-31.6318,7.5537c-.4878,.873-.9233,1.5684-1.459,2.1191-.5098,.5215-1.0591,.9521-1.6646,1.2998-.0415-1.6973,.2144-3.543,.7949-3.7002,.8892-.2402,1.4995-1.0566,1.478-1.9775s-.6694-1.708-1.5688-1.9062c-.5034-.1113-.8608-1.9111-.854-3.6895,.6182,.3164,1.187,.7246,1.7168,1.2285,.5449,.5186,.9946,1.1885,1.5024,2.0352,.0906,.1509,.1895,.2699,.2882,.3882-.2075,.4802-.335,.9954-.3331,1.5376l.002,.1211c.0123,.6792,.2295,1.3304,.5829,1.9072-.1724,.1724-.3386,.3716-.4858,.6367Zm10.0453-13.5963c1.2659-.0643,2.1429,.2085,2.7122,.5394-.5089,.2161-.8585,.3885-.9943,.4583-1.1868,.5476-2.1113,1.0171-2.9312,1.4778,.0821-.6484,.3827-1.5132,1.2134-2.4755Zm18.0484,13.2955c-1.1255,2.3877-2.688,3.9082-4.7754,4.6475-4.377,1.5498-9.5645-.9277-9.6113-.9521-.0337-.0156-.0674-.0312-.1016-.0459-2.5771-1.0947-3.7734-1.792-5.48-2.9424-1.063-.7158-1.7593-1.252-2.4966-1.8193-.5195-.4004-1.0342-.7959-1.6704-1.251,.6245-.4717,1.1357-.8887,1.6523-1.3096,.7236-.5898,1.4077-1.1475,2.4531-1.8965,1.6831-1.2041,2.8647-1.9404,5.4155-3.1152,.0308-.0137,.0654-.0312,.0952-.0469,.0513-.0273,5.2046-2.6826,9.6196-1.249,2.0952,.6787,3.6836,2.1543,4.8843,4.5635,.0513,.0996,1.2441,2.4502,.0151,5.417Z" />
		</SvgIcon>
	);
}

function SVGVegano(props) {
	return (
		<SvgIcon {...props} viewBox={"0 0 48 48"}>
			<path d="M38.172,5.2194c-.2314-.5-.6582-.8818-1.1807-1.0566-.521-.1748-1.0933-.126-1.5791,.1338-16.629,8.9052-15.9945,23.677-13.0592,31.2043l-.7435,1.6794L13.4899,18.0515c-.4312-1.0166-1.6064-1.4922-2.6221-1.0596-1.0171,.4316-1.4912,1.6055-1.0596,2.6221l9.9219,23.376c.311,.7334,1.0283,1.2129,1.8257,1.2188h.0151c.791,0,1.5083-.4668,1.8286-1.1904l2.4879-5.6206c6.5985-3.0249,11.0339-7.4006,13.1571-13.0308,3.5439-9.4004-.6909-18.7539-.8726-19.1475Zm-2.8823,17.7676c-1.3375,3.5262-3.8528,6.4755-7.4742,8.8192l3.6861-8.33c.3354-.7578-.0068-1.6436-.7646-1.9795-.7583-.3359-1.644,.0078-1.9785,.7646l-3.6442,8.2352c-1.0229-5.4213-.7372-14.6869,10.1804-21.5135,.9043,2.9453,2.0571,8.5684-.0049,14.0039Z" />
		</SvgIcon>
	);
}

function SVGVegetariano(props) {
	return (
		<SvgIcon {...props} viewBox={"0 0 48 48"}>
			<path d="M26.2143,27.3049l2.3929-6.895c.2715-.7832-.1426-1.6377-.9253-1.9092-.7832-.2725-1.6377,.1426-1.9087,.9248l-1.1966,3.4478-3.4147-9.2407c-.2881-.7783-1.1509-1.1768-1.9272-.8877-.7769,.2871-1.1743,1.1504-.8872,1.9268l5.8423,15.8101-1.7852-.6616c-.7754-.2852-1.6392,.1094-1.9282,.8848-.2876,.7773,.1089,1.6396,.8853,1.9277l4.1979,1.5559,.4315,1.1677c.2241,.6064,.7974,.9805,1.4072,.9805,.1729,0,.3486-.0293,.52-.0928,.7769-.2871,1.1743-1.1504,.8872-1.9268l-2.5912-7.0122Z" />
			<path d="M32.7684,11.4597c-.4971-.7539-1.5469-1.6113-2.9365-1.625-.8511-.0264-1.6895,.293-2.4849,.9014-1.9683-2.5547-5.7939-6.3525-11.2896-6.627-.6987-.0508-1.3784,.3037-1.7686,.8945-.2632,.3975-6.0884,9.4844-.0796,23.1104-.2568,.1553-.4922,.3281-.707,.5186-1.4023,1.2461-1.543,3.3662-.3193,4.8271,6.4067,7.6387,16.1675,10.3584,16.5796,10.4697,.1733,.0479,.3496,.0703,.5244,.0703,.5078,0,1.0044-.1934,1.3813-.5537,.373-.3564,3.6812-3.791,4.8154-14.4385,1.0981-10.3057-3.2505-16.8789-3.7153-17.5479Zm-.2622,17.124c-.6729,6.3154-2.144,9.627-2.9824,11.0645-2.5981-.9277-8.5752-3.4551-12.8643-8.2812,.1616-.0557,.3682-.1094,.6299-.1533,.6299-.1045,1.1719-.5039,1.459-1.0742s.2842-1.2432-.0068-1.8115c-5.2075-10.1514-2.8745-17.458-1.6689-20.0732,5.1562,1.0273,8.2515,6.6133,8.2822,6.6699,.3335,.6211,.9692,1.0205,1.6733,1.0518,.7031,.0322,1.373-.3105,1.7598-.8994,.3789-.5771,.6729-.8955,.8667-1.0684,.7583,1.2363,3.6992,6.6221,2.8516,14.5752Z" />
		</SvgIcon>
	);
}

const useStyles = makeStyles((theme) => ({
	sizeAvatarBig: {
		width: theme.spacing(4),
		height: theme.spacing(4),
	},
	sizeAvatarRegular: {
		width: theme.spacing(4),
		height: theme.spacing(4),
	},
	sizeAvatarSmall: {
		width: theme.spacing(3.1),
		height: theme.spacing(3.1),
	},
	vegetarianoSmall: {
		border: "1px solid #6C9B2F",
		backgroundColor: "#fff",
	},
	veganoSmall: {
		border: "1px solid #086D40",
		backgroundColor: "#fff",
	},
	pesceSmall: {
		border: "1px solid #49B9AD",
		backgroundColor: "#fff",
	},
	carneSmall: {
		border: "1px solid #E85414",
		backgroundColor: "#fff",
	},
	vegetarianoRegular: {
		backgroundColor: "#6C9B2F",
	},
	veganoRegular: {
		backgroundColor: "#086D40",
	},
	pesceRegular: {
		backgroundColor: "#49B9AD",
	},
	carneRegular: {
		backgroundColor: "#E85414",
	},
	vegetarianoBig: {
		backgroundColor: "#6C9B2F",
	},
	veganoBig: {
		backgroundColor: "#086D40",
	},
	pesceBig: {
		backgroundColor: "#49B9AD",
	},
	carneBig: {
		backgroundColor: "#E85414",
	},
}));

export function IconFromDiet(props) {
	const classes = useStyles();
	let classAvatarSize = classes.sizeAvatarRegular;
	let classAvatarColor = classes.veganoBig;
	let styleIconSize = {
		width: "1em",
		height: "1em",
	};
	let htmlColor = "#ffff";

	switch (props.size) {
		case "small":
			classAvatarSize = classes.sizeAvatarSmall;
			styleIconSize = {
				width: "0.8em",
				height: "0.8em",
			};
			break;
        case "regular":
        default:
			classAvatarSize = classes.sizeAvatarRegular;
			styleIconSize = {
				width: "1em",
				height: "1em",
			};
			break;
		case "big":
			classAvatarSize = classes.sizeAvatarBig;
			styleIconSize = {
				width: "1em",
				height: "1em",
			};
			break;
	}

	let IconSelected = null;

	switch (props.diet) {
		case "Contiene derivati della carne o pesce":
			IconSelected = SVGCarne;
			switch (props.size) {
				case "small":
					htmlColor = "#E85414";
					classAvatarColor = classes.carneSmall;
					break;
				case "regular":
                default:
					classAvatarColor = classes.carneRegular;
					break;
				case "big":
					classAvatarColor = classes.carneBig;
					break;
			}
			break;
		case "Pescetariano":
			IconSelected = SVGPesce;
			switch (props.size) {
				case "small":
					htmlColor = "#49B9AD";
					classAvatarColor = classes.pesceSmall;
					break;
				case "regular":
                default:
					classAvatarColor = classes.pesceRegular;
					break;
				case "big":
					classAvatarColor = classes.pesceBig;
					break;
			}
			break;
		case "Vegetariano":
			IconSelected = SVGVegetariano;
			switch (props.size) {
				case "small":
					htmlColor = "#6C9B2F";
					classAvatarColor = classes.vegetarianoSmall;
					break;
				case "regular":
                default:
					classAvatarColor = classes.vegetarianoRegular;
					break;
				case "big":
					classAvatarColor = classes.vegetarianoBig;
					break;
			}
			break;
		case "Vegano":
			IconSelected = SVGVegano;
			switch (props.size) {
				case "small":
					htmlColor = "#086D40";
					classAvatarColor = classes.veganoSmall;
					break;
				case "regular":
                default:
					classAvatarColor = classes.veganoRegular;
					break;
				case "big":
					classAvatarColor = classes.veganoBig;
					break;
			}
			break;
		default:
			break;
	}

	if (!IconSelected) {
		return null;
	}

	return (
		<Avatar className={`${classAvatarSize} ${classAvatarColor}`}>
			<IconSelected htmlColor={htmlColor} style={styleIconSize} />
		</Avatar>
	);
}

const useStylesDiet = makeStyles((theme) => ({
	container: {
		top: "8px",
		right: "8px",
		width: "100%",
		whiteSpace: "nowrap",
		flexDirection: "column",
		overflow: "hidden",
		position: "absolute",
		display: "flex",
		pointerEvents: "none",
		alignItems: "flex-end",
	},
}));

export function Diet(props) {
	const classes = useStylesDiet();
	return (
		<div className={classes.container}>
			<IconFromDiet size="regular" diet={props.diet} />
		</div>
	);
}
